import { AppDispatch } from '../index';
import { setAuthData } from '../slices/authSlice';

/**
 * Store authentication data in Redux store
 */
export const storeAuthData = (dispatch: AppDispatch, response: any): void => {
  const authData: {
    token?: string;
    jwt?: string;
    email?: string;
    name?: string;
  } = {};

  if (response.data?.token) {
    authData.token = response.data.token;
  }
  if (response.data?.jwt) {
    authData.jwt = response.data.jwt;
  }
  if (response.data?.email) {
    authData.email = response.data.email;
  }
  if (response.data?.name) {
    authData.name = response.data.name;
  }

  dispatch(setAuthData(authData));
};
